import script from "./InquiryForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InquiryForm.vue?vue&type=script&setup=true&lang=js"

import "./InquiryForm.vue?vue&type=style&index=0&id=2baf67ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2baf67ff"]])

export default __exports__